import React,{ useState } from "react";

export default function Visuals() {
	const [language, setLanguage] = useState("en");
	
		const copy = {
			en: {
				kicker: "Video Designer · Live Visuals · Pixel Mapping · Projection Mapping · Event Close Circuit",
				heroTitle: <>Joey<br />Lalo</>,
				heroSubtitle: "Video designer for live enterneinment.",
				yearsLive: "Years in video for live entertainment",
				yearsVideo: "Years training & experience in video, editing and animation",
				aboutKicker: "About",
				aboutTitle: "Creative vision and technical execution.",
				aboutText: [
					"My work sits at the intersection of storytelling, engineering, and real-time execution — combining cinematic design, projection & pixel mapping, programming, and live show operation.",
					"With a background in film, computer science, and visual systems, I specialize in turning creative ideas into reliable immersive visual experiences that perform under the pressure of live events."
				],
				specialtiesKicker: "Specialties",
				specialtiesTitle: "What I do",
				galleryKicker: "Gallery",
				galleryTitle: "",
				galleryText: "",
				productionsKicker: "Selected Productions",
				productionsTitle: "Recent work",
				toolsKicker: "Tools",
				toolsTitle: "Software & hardware",
				educationKicker: "Education",
				educationTitle: "Film, code, and Video Design",
				contactKicker: "Contact",
				finalLine: "Available for live entertainment, theater, concerts, events, mapping, Closed Circuit Camera and More...",
				toggleLabel: "Español",
				skills: [
					"Video Design",
					"Projection Mapping",
					"Pixel Mapping",
					"Show Programming",
					"LED Walls",
					"Showrunning"
				],
				galleryLabels: [
				]
			},
			es: {
				kicker: "Diseño de Video · Visuales Digitales · Pixel Mapping · Projection Mapping · Circuito Cerrado",
				heroTitle: <>Joey<br />Lalo</>,
				heroSubtitle: "Diseñador de visuales digitales para eventos en vivo.",
				yearsLive: "Años en video para entretenimiento en vivo",
				yearsVideo: "Años de formación & experiencia en video, edición y animación",
				aboutKicker: "Sobre mí",
				aboutTitle: "Visión creativa y ejecución técnica.",
				aboutText: [
					"Mi trabajo vive entre la narrativa, la ingeniería y la ejecución en tiempo real — combinando diseño cinematográfico, projection & pixel mapping, programación y operación de shows en vivo.",
					"Con formación en cine, programación y sistemas visuales, convierto ideas creativas en experiencias inmersivas, confiables y listas para la presión de un evento en vivo."
				],
				specialtiesKicker: "Especialidades",
				specialtiesTitle: "Qué hago",
				galleryKicker: "Galería",
				galleryTitle: "Imágenes del trabajo",
				galleryText: "Reemplaza estas rutas con fotos de tus shows, pantallas LED, mapping, setups backstage y momentos de operación en vivo.",
				productionsKicker: "Producciones seleccionadas",
				productionsTitle: "Trabajo reciente",
				toolsKicker: "Herramientas",
				toolsTitle: "Software y hardware",
				educationKicker: "Educación",
				educationTitle: "Cine, código y visuales digitales",
				contactKicker: "Contacto",
				finalLine: "Disponible para entretenimiento en vivo, teatro, conciertos, eventos, mapping, Circuito Cerrado y más...",
				toggleLabel: "English",
				skills: [
					"Diseño de Video",
					"Projection Mapping",
					"Pixel Mapping",
					"Programación de Show",
					"Pantallas LED",
					"Showrunning"
				],
				galleryLabels: [
					"Visuales en vivo",
					"Programación LED",
					"Projection Mapping",
					"Operación de show",
					"Diseño teatral",
					"Sistemas para conciertos"
				]
			}
		};
	
		const t = copy[language];
	
		const projects = [
			{ title: "Rock of Ages: All Night Long", role: "Designer · LED Mapping · Technical Supervisor · Programmer · Video Show Runner", year: "2026" },
			{ title: "Liga de Football Kiwanis Intro", role: "Design · LED Mapping · Programmer", year: "2026" },
			{ title: "SAY Young Adult Group Event", role: "Designer · Programmer · Closed Circuit · Showrunner", year: "2026" },
			{ title: "The Producers", role: "Designer · LED Mapping · Programmer · Video Show Runner", year: "2025" },
			{ title: "1903 El Musical Tour", role: "Designer · LED Mapping · Programmer · Video Show Runner", year: "2025" },
			{ title: "Billy Elliot El Musical", role: "Designer · Programmer · Video Show Runner", year: "2025" },
			{ title: "Millenium at The Plaza Concert", role: "Designer · Programmer · Technical Supervisor", year: "2025" },
			{ title: "IAE Rocks School Concert", role: "Design · LED Mapping · Programmer", year: "2024–2026" },
			{ title: "Tarzan Junior El Musical IAE", role: "Designer · Video Show Runner", year: "2024" },
			{ title: "Anastasia El Musical", role: "Visual Design Support · Video Wall Show Runner", year: "2024" }
		];
	
		const tools = [
			"Resolume Arena",
			"Resolume Alley",
			"MadMapper",
			"TouchDesigner",
			"Blender",
			"Maya",
			"DaVinci Resolve Studio",
			"After Effects",
			"Premiere Pro",
			"Photoshop",
			"Illustrator",
			"Blackmagic ATEM Software",
			"Chaser",
			"NovaStar Controller Software",
			"LED Walls",
			"NovaStar VX1000",
			"Blackmagic ATEM",
			"Projection Systems",
			"MacBook Pro M3 Max",
			"Windows Media Systems"
		];
	
		const galleryImages = [
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-01.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-02.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-03.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-04.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-05.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-06.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-07.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-08.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-09.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-10.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-11.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-12.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-13.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-14.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-15.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-16.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-17.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-18.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-19.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-20.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-21.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-22.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-23.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-24.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-25.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-26.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-27.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-28.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-29.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-30.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-31.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-32.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-33.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-34.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-35.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-36.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-37.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-38.avif", alt: "" },
			{ src: "https://f005.backblazeb2.com/file/PhotosSite/Pantallas/PR-39.avif", alt: "" }
		];
	
		return (
			<main className="joey-cv">
				<style>{`
					.joey-cv {
						--bg: #06070d;
						--panel: #10121d;
						--text: #f5f7ff;
						--muted: #c8ccdc;
						--line: rgba(245,247,255,0.16);
						--accent: #a7c8ff;
						--accent-2: #c79aff;
						--accent-3: #8ee7ff;
						--soft-white: #f4f4f4;
	
						background: var(--bg);
						color: var(--text);
						font-family: Arial, Helvetica, sans-serif;
						line-height: 1.5;
						position: relative;
					}
	
					.joey-cv * {
						box-sizing: border-box;
					}
	
					.cv-language-toggle {
						position: fixed;
						top: 22px;
						right: 22px;
						z-index: 20;
						border: 1px solid rgba(245,247,255,0.25);
						background: rgba(16,18,29,0.72);
						color: var(--text);
						border-radius: 999px;
						padding: 10px 16px;
						font-weight: 900;
						letter-spacing: 0.8px;
						text-transform: uppercase;
						cursor: pointer;
						backdrop-filter: blur(14px);
						box-shadow: 0 12px 30px rgba(0,0,0,0.3), 0 0 30px rgba(167,200,255,0.16);
					}
	
					.cv-language-toggle:hover {
						border-color: var(--accent);
						background: rgba(167,200,255,0.14);
					}
	
					.cv-slide {
						width: 100%;
						min-height: 100vh;
						padding: 64px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						position: relative;
						overflow: hidden;
						border-bottom: 1px solid var(--line);
					}
	
					.cv-slide::before {
						content: "";
						position: absolute;
						inset: 0;
						background:
							radial-gradient(circle at 78% 18%, rgba(167,200,255,0.26), transparent 30%),
							radial-gradient(circle at 18% 82%, rgba(199,154,255,0.24), transparent 33%),
							radial-gradient(circle at 58% 55%, rgba(142,231,255,0.12), transparent 28%),
							linear-gradient(120deg, rgba(244,244,244,0.06), transparent 35%);
						pointer-events: none;
					}
	
					.cv-slide::after {
						content: "";
						position: absolute;
						inset: 0;
						background-image: linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
						background-size: 48px 48px;
						mask-image: linear-gradient(to bottom, transparent, black 25%, black 75%, transparent);
						pointer-events: none;
					}
	
					.cv-content {
						position: relative;
						z-index: 2;
						max-width: 1180px;
						margin: 0 auto;
						width: 100%;
					}
	
					.cv-kicker {
						color: var(--accent);
						font-weight: 800;
						text-transform: uppercase;
						letter-spacing: 3px;
						font-size: 13px;
						margin-bottom: 18px;
					}
	
					.cv-title {
						font-size: clamp(70px, 12vw, 156px);
						line-height: 0.82;
						letter-spacing: -7px;
						margin: 0 0 28px;
						text-transform: uppercase;
						text-shadow: 0 0 34px rgba(167,200,255,0.22);
					}
	
					.cv-section-title {
						font-size: clamp(42px, 6vw, 88px);
						line-height: 0.92;
						letter-spacing: -3.5px;
						margin: 0 0 28px;
						text-transform: uppercase;
					}
	
					.cv-subtitle {
						font-size: clamp(22px, 3vw, 38px);
						font-weight: 800;
						max-width: 980px;
						color: var(--soft-white);
						line-height: 1.08;
					}
	
					.cv-text {
						font-size: 20px;
						color: var(--muted);
						max-width: 820px;
						margin: 0 0 18px;
					}
	
					.cv-contact-strip {
						display: flex;
						flex-wrap: wrap;
						gap: 14px;
						margin-top: 42px;
						color: var(--muted);
						font-size: 15px;
					}
	
					.cv-pill {
						border: 1px solid var(--line);
						border-radius: 999px;
						padding: 9px 13px;
						background: rgba(255,255,255,0.04);
					}
	
					.cv-hero-grid {
						display: grid;
						grid-template-columns: 1.25fr 0.75fr;
						gap: 48px;
						align-items: end;
					}
	
					.cv-stat-card {
						border: 1px solid var(--line);
						background: linear-gradient(145deg, rgba(167,200,255,0.12), rgba(199,154,255,0.08));
						padding: 28px;
						backdrop-filter: blur(8px);
						box-shadow: 0 22px 60px rgba(0,0,0,0.22);
					}
	
					.cv-stat {
						font-size: 58px;
						line-height: 1;
						font-weight: 900;
						color: var(--accent);
					}
	
					.cv-stat-label {
						text-transform: uppercase;
						font-size: 12px;
						letter-spacing: 2px;
						color: var(--muted);
						margin-top: 8px;
					}
	
					.cv-card-grid,
					.cv-gallery-grid,
					.cv-education-grid {
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						gap: 18px;
						margin-top: 34px;
					}
	
					.cv-skill-card {
						min-height: 160px;
						padding: 24px;
						border: 1px solid var(--line);
						background: linear-gradient(145deg, rgba(167,200,255,0.13), rgba(199,154,255,0.06));
						display: flex;
						flex-direction: column;
						justify-content: space-between;
					}
	
					.cv-skill-card span {
						color: var(--accent-2);
						font-size: 12px;
						text-transform: uppercase;
						letter-spacing: 2px;
						font-weight: 800;
					}
	
					.cv-skill-card strong {
						font-size: 26px;
						line-height: 1;
						text-transform: uppercase;
					}
	
					.cv-gallery-item {
						position: relative;
						min-height: 260px;
						overflow: hidden;
						border: 1px solid var(--line);
						background: linear-gradient(145deg, rgba(167,200,255,0.12), rgba(199,154,255,0.09));
						margin: 0;
					}
	
					.cv-gallery-item img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: block;
						aspect-ratio: 4 / 3;
						filter: saturate(0.95) contrast(1.08);
						transition: transform 0.5s ease, filter 0.5s ease;
					}
	
					.cv-gallery-item:hover img {
						transform: scale(1.04);
						filter: saturate(1.12) contrast(1.12);
					}
	
					.cv-gallery-label {
						position: absolute;
						left: 14px;
						right: 14px;
						bottom: 14px;
						padding: 10px 12px;
						background: rgba(6,7,13,0.72);
						border: 1px solid var(--line);
						backdrop-filter: blur(10px);
						font-weight: 900;
						text-transform: uppercase;
						letter-spacing: 1px;
						font-size: 12px;
					}
	
					.cv-project-list {
						display: grid;
						gap: 14px;
						margin-top: 34px;
					}
	
					.cv-project {
						display: grid;
						grid-template-columns: 1.1fr 0.65fr 0.25fr;
						gap: 22px;
						align-items: center;
						padding: 18px 0;
						border-bottom: 1px solid var(--line);
					}
	
					.cv-project-title {
						font-size: 25px;
						font-weight: 900;
						letter-spacing: -0.6px;
					}
	
					.cv-project-role {
						color: var(--muted);
						font-size: 15px;
					}
	
					.cv-project-year {
						text-align: right;
						color: var(--accent);
						font-weight: 900;
					}
	
					.cv-software-cloud {
						display: flex;
						flex-wrap: wrap;
						gap: 10px;
						margin-top: 32px;
						max-width: 920px;
					}
	
					.cv-software-cloud span {
						font-size: 15px;
						font-weight: 800;
						padding: 10px 12px;
						border: 1px solid var(--line);
						background: rgba(255,255,255,0.06);
						border-radius: 999px;
					}
	
					.cv-edu {
						border: 1px solid var(--line);
						background: linear-gradient(145deg, rgba(167,200,255,0.10), rgba(199,154,255,0.07));
						padding: 24px;
						min-height: 220px;
					}
	
					.cv-edu small {
						color: var(--accent-2);
						text-transform: uppercase;
						letter-spacing: 2px;
						font-weight: 900;
					}
	
					.cv-edu h3 {
						font-size: 26px;
						margin: 0 0 8px;
					}
	
					.cv-edu p {
						font-size: 16px;
						color: var(--muted);
						margin-top: 12px;
					}
	
					.cv-final-line {
						font-size: clamp(38px, 7vw, 96px);
						line-height: 0.95;
						font-weight: 950;
						letter-spacing: -3px;
						text-transform: uppercase;
						max-width: 1100px;
					}
	
					@media (max-width: 900px) {
						.cv-language-toggle {
							top: 12px;
							right: 12px;
						}
	
						.cv-slide {
							padding: 72px 24px 36px;
						}
	
						.cv-hero-grid,
						.cv-card-grid,
						.cv-gallery-grid,
						.cv-education-grid,
						.cv-project {
							grid-template-columns: 1fr;
						}
	
						.cv-project-year {
							text-align: left;
						}
	
						.cv-title {
							letter-spacing: -4px;
						}
					}
				`}</style>
	
				<button className="cv-language-toggle" type="button" onClick={() => setLanguage(language === "en" ? "es" : "en")}>
					{t.toggleLabel}
				</button>
	
				<section className="cv-slide">
					<div className="cv-content cv-hero-grid">
						<div>
							<div className="cv-kicker">{t.kicker}</div>
							<h1 className="cv-title">{t.heroTitle}</h1>
							<div className="cv-subtitle">{t.heroSubtitle}</div>
	
							<div className="cv-contact-strip">
								<span className="cv-pill">mirumprod@gmail.com</span>
								<span className="cv-pill">+507 6674-3396</span>
								<span className="cv-pill">+1 202-664-2098</span>
								<span className="cv-pill">@mirumproductions</span>
							</div>
						</div>
	
						<div className="cv-stat-card">
							<div className="cv-stat">2+</div>
							<div className="cv-stat-label">{t.yearsLive}</div>
							<br />
							<div className="cv-stat">7</div>
							<div className="cv-stat-label">{t.yearsVideo}</div>
						</div>
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.aboutKicker}</div>
						<h2 className="cv-section-title">{t.aboutTitle}</h2>
						{t.aboutText.map((paragraph) => (
							<p className="cv-text" key={paragraph}>{paragraph}</p>
						))}
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.specialtiesKicker}</div>
						<h2 className="cv-section-title">{t.specialtiesTitle}</h2>
	
						<div className="cv-card-grid">
							{t.skills.map((skill, index) => (
								<div className="cv-skill-card" key={skill}>
									<span>{String(index + 1).padStart(2, "0")}</span>
									<strong>{skill}</strong>
								</div>
							))}
						</div>
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.galleryKicker}</div>
						<h2 className="cv-section-title">{t.galleryTitle}</h2>
						<p className="cv-text">{t.galleryText}</p>
	
						<div className="cv-gallery-grid">
							{galleryImages.map((image, index) => (
								<figure className="cv-gallery-item" key={image.src}>
									<img src={image.src} alt={image.alt} />
									{//<figcaption className="cv-gallery-label">{t.galleryLabels[index]}</figcaption>
									}
								</figure>
							))}
						</div>
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.productionsKicker}</div>
						<h2 className="cv-section-title">{t.productionsTitle}</h2>
	
						<div className="cv-project-list">
							{projects.map((project) => (
								<div className="cv-project" key={project.title}>
									<div className="cv-project-title">{project.title}</div>
									<div className="cv-project-role">{project.role}</div>
									<div className="cv-project-year">{project.year}</div>
								</div>
							))}
						</div>
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.toolsKicker}</div>
						<h2 className="cv-section-title">{t.toolsTitle}</h2>
	
						<div className="cv-software-cloud">
							{tools.map((tool) => (
								<span key={tool}>{tool}</span>
							))}
						</div>
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.educationKicker}</div>
						<h2 className="cv-section-title">{t.educationTitle}</h2>
	
						<div className="cv-education-grid">
							<div className="cv-edu">
								<small>New York University</small>
								<h3>Tisch School of the Arts</h3>
								<p>Film & Television with a minor in Computer Science.</p>
							</div>
	
							<div className="cv-edu">
								<small>Georgia Tech</small>
								<h3>Online M.S. in Computer Science</h3>
								<p>Currently pursuing. Estimated graduation: 2028/2029.</p>
							</div>
	
							<div className="cv-edu">
								<small>Argentina</small>
								<h3>Visuales Digitales</h3>
								<p>Completed a one-year specialized program at Instituto de Formación en Oficios del Espectáculo.</p>
							</div>
						</div>
					</div>
				</section>
	
				<section className="cv-slide">
					<div className="cv-content">
						<div className="cv-kicker">{t.contactKicker}</div>
						<div className="cv-final-line">{t.finalLine}</div>
	
						<div className="cv-contact-strip">
							<span className="cv-pill">Joey Lalo</span>
							<span className="cv-pill">mirumprod@gmail.com</span>
							<span className="cv-pill">+507 6674-3396</span>
							<span className="cv-pill">+1 202-664-2098</span>
						</div>
					</div>
				</section>
			</main>
		);
	}
	